import { render, staticRenderFns } from "./UserInitSection.vue?vue&type=template&id=2aea1096&scoped=true"
import script from "./UserInitSection.vue?vue&type=script&lang=ts"
export * from "./UserInitSection.vue?vue&type=script&lang=ts"
import style0 from "./UserInitSection.vue?vue&type=style&index=0&id=2aea1096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aea1096",
  null
  
)

export default component.exports